import { FormDialogTemplate } from "../../../../../../../shared/form-dialog/form-dialog.template";
import { Injector, Output, EventEmitter } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { PartDetailService } from "../../part-detail.service";
import { PartListService } from "../../../part-list.service";
import { PartLoadingService } from "../../../../../phf.service";
import { PartLoadingTabComponent } from "../part-loading-tab.component";

export class UnloadingMethodDialogTemplate extends FormDialogTemplate {

    dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
    editformworker: any;

    constructor(
        private readonly injector: Injector,
        private readonly messageService: PartDetailService,
        private readonly partListService: PartListService,
        private readonly partLoadingTabComponent: PartLoadingTabComponent
    ) {
        super();
        const formbuilder = injector.get(FormBuilder);
        const editform = formbuilder.group(
            {
                UnloadingMethod: []
            }
        );
        this.initilize("- " + partLoadingTabComponent.part.Code, editform, this.formDialogTabs);
    }
    cancel = x => {
        this.partLoadingTabComponent.partDetailComponent.isVisDialog = true;
        this.next(null);
        this.partListService.closeDialog();
        this.partLoadingTabComponent.isOpen = true;
        this.partLoadingTabComponent.displayFunction();
    }
    save = ({ dataItem }): void => {
        this.next(null);
        this.partListService.closeDialog();
        this.partLoadingTabComponent.isOpen = true;
        this.partLoadingTabComponent.displayFunction();
        this.partLoadingTabComponent.partDetailComponent.isVisDialog = true;
        this.partLoadingTabComponent.partLoadingTabSave = false;
        this.partLoadingTabComponent.setUnloadingValue(dataItem.UnloadingMethod);
    }
    formControls = [
        {
            type: "textarea",
            name: "UnloadingMethod",
            rows: 4,
            title: "Unloading Method Note",
            stretch: true,
        }
    ]
    formDialogTabs = [
        {
            title: "Unloading Method",
            selected: true,
            formControls: this.formControls
        },
    ]

}
